<template>
    <b-modal
        v-model="modal"
        hide-footer
        centered
        modal-class="modal-banned"
        dialog-class="max-w-320-px mx-auto"
        body-class="pt-0 pb-4s px-3s"
        content-class="border-1 border-pattens-blue"
        @hidden="onHidden"
    >
        <template #modal-header>
            <div class="modal-header-wrapper text-right w-100">
                <b-button
                    variant="transparent"
                    class="btn-close p-0"
                    @click="modal = false"
                >
                    <i class="far fa-times text-xl text-grey"></i>
                </b-button>
            </div>
        </template>
        <div class="text-center">
            <div class="mb-3s">
                <img
                    src="@/assets/images/auth/banned-icon.svg"
                    alt="1Byte banned"
                    loading="lazy"
                    class="w-160-px mx-auto"
                />
            </div>
            <div class="text-grey mb-3s">
                <i18n path="auth.account_banned_message" tag="span">
                    <template #tos>
                        <span class="text-lowercase">
                            {{ $t('auth.tos') }}
                        </span>
                    </template>
                </i18n>
            </div>
            <b-button
                variant="cinnabar"
                size="lg"
                block
                class="text-hover-white text-lg h-48-px font-weight-600"
                @click="redirectTOS"
            >
                {{ $t('button.view_detail') }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'ModalUserBanned',
    computed: {
        ...mapState('authentication', ['popupBanned']),
        modal: {
            get() {
                return this.popupBanned;
            },
            set(value) {
                this.$store.commit('authentication/setPopupBanned', value);
            },
        },
    },
    methods: {
        ...mapActions('auth', ['logout']),
        redirectTOS() {
            this.$helpers.redirectStore('/term-and-conditions');
        },
        onHidden() {
            this.logout({ needContinueUrl: false });
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'ModalUserBanned';
</style>
